if (!customElements.get("m-localization-form")) {
  class MLocalizationForm extends HTMLElement {
    constructor() {
      super();
      const select = this.querySelector('[data-localization-select]');
      select && select.addEventListener('change', (e) => {
        const value = e.target.value
        const form = select.closest('[data-localization-form]')
        const input = form.querySelector('input[data-localization-input]')
        input && input.setAttribute('value', value)
        input && form.submit()
      });
    }
  }
  customElements.define('m-localization-form', MLocalizationForm);
}
window.addEventListener('load', function() {
  function updateFlag() {
    document.querySelectorAll('.m-language-switcher').forEach(function(switcher) {
      const select = switcher.querySelector('[data-localization-select]');
      const trigger = switcher.querySelector('.m-select-custom--trigger-text');
      if (!select || !trigger) return;

      const lang = select.value;
      const flags = {
        'en': '🇺🇸',
        'ar': '🇶🇦'
      };

      trigger.textContent = flags[lang] || '🌐';
      trigger.style.fontSize = '20px';
    });
  }

  updateFlag();

  document.querySelectorAll('[data-localization-select]').forEach(function(select) {
    select.addEventListener('change', updateFlag);
  });
});